import {
  PERFILES_GET_FUNCTIONS_MODULES_BEGIN,
  PERFILES_GET_FUNCTIONS_MODULES_SUCCESS,
  PERFILES_GET_FUNCTIONS_MODULES_FAILURE,
  PERFILES_GET_FUNCTIONS_MODULES_DISMISS_ERROR,
} from './constants';
import axios from "axios";
import { REACT_APP_API_ABM_FW } from '../../../common/config';
// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function getFunctionsModules(args = '') {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: PERFILES_GET_FUNCTIONS_MODULES_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      const doRequest = axios.get(REACT_APP_API_ABM_FW + "/functionsmodule" + args);
      doRequest.then(
        (res) => {
          if (res.data.success) {
            dispatch({
              type: PERFILES_GET_FUNCTIONS_MODULES_SUCCESS,
              data: res,
            });
            resolve(res.data.data);
          } else {
            dispatch({
              type: PERFILES_GET_FUNCTIONS_MODULES_FAILURE,
              data: [],
            });
            reject();
          }
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: PERFILES_GET_FUNCTIONS_MODULES_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetFunctionsModulesError() {
  return {
    type: PERFILES_GET_FUNCTIONS_MODULES_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PERFILES_GET_FUNCTIONS_MODULES_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getFunctionsModulesPending: true,
        getFunctionsModulesError: null,
      };

    case PERFILES_GET_FUNCTIONS_MODULES_SUCCESS:
      // The request is success
      return {
        ...state,
        getFunctionsModulesPending: false,
        getFunctionsModulesError: null,
      };

    case PERFILES_GET_FUNCTIONS_MODULES_FAILURE:
      // The request is failed
      return {
        ...state,
        getFunctionsModulesPending: false,
        getFunctionsModulesError: action.data.error,
      };

    case PERFILES_GET_FUNCTIONS_MODULES_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getFunctionsModulesError: null,
      };

    default:
      return state;
  }
}
